<template>
  <div class="p-4" role="status">
    <SvgIcon v-show="showSpinner" icon="loading-spinner" />
    <div v-show="!showSpinner" class="h-8"></div>
    <span class="sr-only">Loading...</span>
  </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import SvgIcon from '@/assets/SvgIcon.vue';

const showSpinner = ref(false);
const route = useRoute();

onMounted(() => {
  setTimeout(() => {
    showSpinner.value = true;
  }, 300);
});

watch(route, async () => {
  showSpinner.value = false;
  setTimeout(() => {
    showSpinner.value = true;
  }, 300);
});
</script>
